import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const GoogleAuthCallback = () => {
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const code = params.get('code');
    const error = params.get('error');

    if (window.opener) {
      if (code) {
        window.opener.postMessage(
          {
            type: 'GOOGLE_OAUTH_SUCCESS',
            code,
          },
          window.location.origin,
        );
      } else {
        window.opener.postMessage(
          {
            type: 'GOOGLE_OAUTH_ERROR',
            error: error || 'Unknown error',
          },
          window.location.origin,
        );
      }
      window.close();
    }
  }, [location]);

  return (
    <div style={{ padding: 20, textAlign: 'center' }}>
      <h2>Processing Google authentication...</h2>
      <p>This window will close automatically.</p>
    </div>
  );
};

export default GoogleAuthCallback;
